export default __webpack_public_path__ + "static/media/pic8.024cc28c.jpg";